import React, { useContext } from 'react'

import { TemplateContext } from '../../components/template/context'
import { SanarLogo2 } from '../../assets/svg/SanarLogo2'
import { ProviLogo } from '../../assets/svg/ProviLogo'
import { MadePossibleProvi2 } from '../../assets/svg/MadePossibleProvi2'
import TypeFormIntegration from '../../components/TypeformIntegration'

import * as S from './styles'

export const CreditAnalysis = () => {
  const { isMobile } = useContext(TemplateContext)

  return (
    <S.Container>
      <S.Header>
        <SanarLogo2 />
        <S.ContainerLogo>{isMobile ? <ProviLogo /> : <></>}</S.ContainerLogo>
      </S.Header>
      <S.Content>
        <S.Title>Sua solicitação entrou em análise!</S.Title>
        <S.SubTitle>
          Você vai receber um email sobre o resultado da análise referente à sua solicitação em até 24h (essa estimativa de
          tempo é válida somente de segunda a sexta-feira, em finais de semana o tempo pode ser mais longo).
        </S.SubTitle>
      </S.Content>
      <S.ContainerLogoProvi>{!isMobile ? <MadePossibleProvi2 /> : <></>}</S.ContainerLogoProvi>
      <TypeFormIntegration id="pOLHbQb9" />
    </S.Container>
  )
}
